import {Component, OnInit, ViewChild} from "@angular/core";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {ActivatedRoute, Router} from "@angular/router";
import {Acesso} from "src/app/core/acesso";
import {CarregarPerfil} from "src/app/core/carregar-perfil";
import {ConfirmDialogComponent} from "../common/confirm-dialog/confirm-dialog.component";
import {Rim} from "../../core/rim";
import {RimService} from "../../services/rim/rim.service";
import {LoadingPopupService} from "../../services/loadingPopup/loading-popup.service";
import {ToastService} from "../../services/toast/toast.service";
import {FileUtils} from "../../utils/file-utils";
import {MatBottomSheet} from "@angular/material/bottom-sheet";
import {BotoesRelatorioRimComponent} from "./botao-relatorio/botao-relatorio.component";
import {DataUtilService} from "../../services/commons/data-util.service";

@Component({
    selector: "rim",
    templateUrl: "./rim.component.html",
    styleUrls: ["./rim.component.css"],
})
export class RimComponent implements OnInit {
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    listaRim: Rim[];
    msg: string;
    mostrarTabela = false;

    unidadeSelecionada;
    contratoSelecionado;
    dataInicio: Date;
    dataFim: Date;

    displayedColumns: string[] = ["modeloPadrao", "unidade", "contrato", "dataInicio", "dataFim", "finalizado", "acoes"];
    dataSource: MatTableDataSource<Rim> = new MatTableDataSource();

    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    constructor(private rimService: RimService,
                private router: Router,
                private dialog: MatDialog,
                private activatedRoute: ActivatedRoute,
                private loadingPopupService: LoadingPopupService,
                private toastService: ToastService,
                private fileUtils: FileUtils,
                private botoesRelatorio: MatBottomSheet,
                private dataUtilService: DataUtilService) {
    }

    ngOnInit() {
        this.carregarPerfil.carregar(
            this.activatedRoute.snapshot.data.perfilAcesso,
            this.perfilAcesso
        );
        this.dataSource.paginator = this.paginator;
        this.pesquisarTodos();
    }

    limpar() {
        this.mostrarTabela = false;
        this.dataSource.data = [];

        this.unidadeSelecionada = null;
        this.contratoSelecionado = null;
        this.dataInicio = null;
        this.dataFim = null;
    }

    consultar() {
        if (this.unidadeSelecionada ||
            this.dataInicio ||
            this.dataFim ||
            this.contratoSelecionado) {
            this.rimService
                .getFilter(this.unidadeSelecionada?.idUnidade,
                    this.dataInicio?.getTime(),
                    this.dataFim?.getTime(),
                    this.contratoSelecionado?.id)
                .subscribe((listaRim: Rim[]) => {
                    this.listaRim = listaRim;
                    this.dataSource.data = listaRim ? listaRim : [];
                    this.verificaMostrarTabela(listaRim);
                });
        } else {
            this.pesquisarTodos();
        }
    }

    atualizar(rim: Rim) {
        this.router.navigate(["/rim/cadastrar"], {
            queryParams: {id: rim.id},
        });
    }

    deletar(rim: Rim) {
        this.chamaCaixaDialogoDeletar(rim);
    }

    chamaCaixaDialogoDeletar(rim: Rim) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: "Excluir RIM",
            textoAuxiliar: "Deseja realmente excluir a RIM?",
            textoConfirma: "SIM",
            textoCancela: "NÃO",
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((confirma) => {
            if (confirma) {
                this.rimService.excluir(rim.id).subscribe(() => this.consultar());
            } else {
                dialogRef.close();
            }
        });
    }

    alterarModeloPadrao(rim: Rim) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: "Alterar modelo padrão",
            textoAuxiliar: "Deseja realmente alterar o modelo padrão?",
            textoConfirma: "SIM",
            textoCancela: "NÃO",
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((confirma) => {
            if (confirma)
                this.rimService.alterarModeloPadrao(rim.id).subscribe(() => this.consultar());
            else
                dialogRef.close();
        });
    }

    finalizar(rim: Rim) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: "Finalizar RIM",
            textoAuxiliar: "Após a finalização do RIM, não será mais possível realizar alterações. Deseja realmente finalizar o RIM?",
            textoConfirma: "SIM",
            textoCancela: "NÃO",
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((confirma) => {
            if (confirma)
                this.rimService.finalizar(rim.id).subscribe(() => this.consultar());
            else
                dialogRef.close();
        });
    }

    pesquisarTodos() {
        this.rimService
            .getAll()
            .subscribe((listaRim: Rim[]) => {
                this.listaRim = listaRim;
                this.dataSource.data = listaRim ? listaRim : [];
                this.verificaMostrarTabela(listaRim);
            });
    }

    verificaMostrarTabela(listaRim: Rim[]) {
        if (!listaRim || listaRim.length == 0) {
            this.mostrarTabela = false;
            this.msg = "Nenhum registro para a pesquisa selecionada";
        } else {
            this.mostrarTabela = true;
        }
    }

    getRelatorio(idRim: number, tipo: string) {
        if (!tipo)
            return;

        this.loadingPopupService.mostrarMensagemDialog('Gerando relatório ..');

        this.rimService.showRelatorio(idRim, tipo).subscribe(
            response => {
                if (tipo == 'PDF') {
                    this.fileUtils.showFilePDF(response);
                } else if (tipo == 'DOCX') {
                    this.fileUtils.downloadFile(response, 'RIM.docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
                }
            },
            responseError => {
                const dataView = new DataView(responseError.error);
                const decoder = new TextDecoder('utf8');
                const resp = JSON.parse(decoder.decode(dataView));
                this.toastService.showAlerta(resp.mensagem);

            }).add(() => {
            this.loadingPopupService.closeDialog();
        });
    }

    abrirOpcoesRelatorio(idRim: number) {
        const botoesRelatorioRef = this.botoesRelatorio.open(BotoesRelatorioRimComponent);
        botoesRelatorioRef.afterDismissed().subscribe((tipo) => {
            this.getRelatorio(idRim, tipo);
        });
    }

    onValorChangeUnidade(registro: any) {
        this.unidadeSelecionada = registro;
    }

    onValorChangeContrato(registro: any) {
        this.contratoSelecionado = registro;
    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

    duplicarRim(rim: Rim) {
        this.router.navigate(["/rim/cadastrar"], {
            queryParams: {id: rim.id, duplicar: true},
        });
    }

    irParaCadastro() {
        const rimPadrao = this.listaRim.find(rim => rim.modeloPadrao == true);
        if (!rimPadrao) {
            this.router.navigate(["/rim/cadastrar"]);
            return;
        }
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: `Ir para cadastro`,
            textoAuxiliar: `Deseja utilizar o Modelo Padrão?`,
            textoConfirma: "Sim",
            textoCancela: "Não",
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((confirma) => {
            if (confirma)
                this.router.navigate(["/rim/cadastrar"], {
                    queryParams: {
                        id: rimPadrao.id,
                        duplicar: true
                    },
                });
            else
                this.router.navigate(["/rim/cadastrar"]);
        });
    }

}
